// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-email-btn:hover {\n  text-decoration: none;\n  color: inherit; }\n", "",{"version":3,"sources":["webpack://src/components/Shared/Buttons/ContactBtn/ContactBtn.scss"],"names":[],"mappings":"AAEA;EAEQ,qBAAqB;EACrB,cAAc,EAAA","sourcesContent":["@import \"../../../../assets/styles/variables\";\n\n.contact-email-btn {\n    &:hover {\n        text-decoration: none;\n        color: inherit;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
